import {
  getCategories,
  getWarehousesPaginated,
} from '../../utils/apiUtils/inventoryUtils';

const useLogisticsDropdowns = () => {
  // Fetch function for warehouses
  const fetchWarehouses = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getWarehousesPaginated({
      pageNumber: pageParam,
      pageSize,
      searchString: searchTerm,
    });
    return response;
  };

  // Fetch function for categories
  const fetchCategories = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getCategories({
      pageNumber: pageParam,
      pageSize,
      searchString: searchTerm,
    });
    return response;
  };

  // Transform warehouse data to dropdown option format
  const transformWarehouseOption = (wh) => ({
    value: wh.roomId,
    label: wh.roomName,
    batchwise: wh.batchwise,
  });

  // Transform category data to dropdown option format
  const transformCategoryOption = (category) => ({
    value: category.inventoryTypeId,
    label: category.inventoryType,
    // description: category.description,
  });

  // Error handler for fetch failures
  const handleFetchError = (errorMessage) => {
    window.triggerAlert({
      title: 'Error',
      type: 'error',
      message: errorMessage,
    });
  };
  return {
    fetchWarehouses,
    fetchCategories,
    handleFetchError,
    transformWarehouseOption,
    transformCategoryOption,
  };
};

export default useLogisticsDropdowns;
